import { Badge, Popover } from 'antd';
import React, { useRef, useState } from 'react';
import { mutateConfig } from '../api/queryBase';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useGetQuery } from '../customhooks/useGetQuery';
import { NotificationsBellIcon, FrontEdgeSmallLogo } from './icons';
import { Notification } from '../interfaces/Notifications';

dayjs.extend(relativeTime);

const Notifications = () => {
    const [open, setOpen] = useState(false);
    const { token } = useSelector((state: RootState) => ({
        token: state.user.token
    }));

    const hide = () => {
        setOpen(false);
    };

    const handleOpenChange = (newOpen: boolean) => {
        setOpen(newOpen);
    };

    const { entries: notifications = [] } = useGetQuery<Notification[]>({
        url: '/corporate/notification',
        cacheKey: 'notifications',
        enabled: Boolean(token)
    });

    return (
        <div className='lg:absolute lg:top-8 top-6 lg:right-10 right-4 cursor-pointer'>
            <Popover
                content={<NotificationContent {...{ hide, notifications }} />}
                trigger='click'
                open={open}
                onOpenChange={handleOpenChange}
                arrow={false}
                placement='bottomLeft'
            >
                <div>
                    <NotificationsBellIcon />
                </div>
            </Popover>
        </div>
    );
};

export default Notifications;

const NotificationContent = ({
    hide,
    notifications
}: {
    hide: () => void;
    notifications: Notification[];
}) => {
    const anchorRefNotification = useRef<HTMLDivElement>(null);
    const mutation = mutateConfig({ method: 'put' });
    const { mutate } = mutation({
        url: `/corporate/notifications/read`,
        cacheKeys: 'notifications'
    });

    const handleCloseNotification = (event?: MouseEvent | TouchEvent) => {
        if (
            anchorRefNotification.current &&
            anchorRefNotification.current.contains(event?.target as Node)
        ) {
            return;
        }
    };

    const onHandleNotificationClick = (notificationIds: number[]) => {
        if (notificationIds.length) {
            mutate({ notificationIds });
            hide();
        }
    };

    return (
        <div className='lg:w-[376px] p-2'>
            <div className='flex justify-between  pb-3'>
                <h1 className='leading-6 text-[18px]'>
                    Notifications (
                    {notifications.filter(({ status }) => status === 1)?.length}
                    )
                </h1>
                <div
                    onClick={() => {
                        const ids = notifications
                            .filter(({ status }) => status === 1)
                            .map(({ id }) => id);
                        onHandleNotificationClick(ids);
                    }}
                    className='leading-6 text-[12px] bg-athensGray px-2 rounded-lg cursor-pointer'
                >
                    Mark all as read
                </div>
            </div>

            <div className='h-[376px] overflow-scroll space-y-4'>
                {notifications.map(({ id, message, createdDate, status }) => (
                    <div
                        onClick={(e) => {
                            handleCloseNotification(e as unknown as MouseEvent);
                            onHandleNotificationClick([id]);
                        }}
                        key={`notification-${id}`}
                    >
                        <Badge status='processing' dot={status === 1 && true}>
                            <div className='flex items-center gap-4 cursor-pointer hover:bg-appcolorfaintseven p-1 rounded-lg'>
                                <div className='rounded-[50%] p-2 border border-appcolorfaintnine '>
                                    <FrontEdgeSmallLogo
                                        width='20'
                                        height='20'
                                    />
                                </div>
                                <div className='w-[290px]'>
                                    <p className='truncate'>{message}</p>
                                    <p className='text-appcolorblackfaint opacity-35 text-[14px] leading-[18px]'>
                                        {dayjs().to(
                                            dayjs(new Date(createdDate))
                                        )}
                                    </p>
                                </div>
                            </div>
                        </Badge>
                    </div>
                ))}
            </div>
        </div>
    );
};
